import { useState, useRef, useEffect } from "react";

const TIER_INFO = {
  bronze: { label: "Bronze", threshold: 5, fill: "#FAEEDA", stroke: "#854F0B", text: "#412402", next: "silver" },
  silver: { label: "Silver", threshold: 15, fill: "#F1EFE8", stroke: "#444441", text: "#2C2C2A", next: "gold" },
  gold: { label: "Gold", threshold: 40, fill: "#FAC775", stroke: "#633806", text: "#412402", next: "platinum" },
  platinum: { label: "Platinum", threshold: 100, fill: "#D9D6FB", stroke: "#3C3489", text: "#26215C", next: null },
};

const PERKS = {
  bronze: "Awarded for completing 5+ jobs.",
  silver: "Awarded for completing 15+ jobs.",
  gold: "Awarded for completing 40+ jobs. Higher visibility in manager searches, early access to new postings.",
  platinum: "Awarded for completing 100+ jobs. Top placement and featured on managers' trusted-worker lists.",
};

export default function WorkerBadge({ tier, size = "sm" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [open]);

  if (!tier || !TIER_INFO[tier]) return null;
  const info = TIER_INFO[tier];
  const dim = size === "lg" ? 32 : 20;

  return (
    <div className="relative inline-block" ref={ref}>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); setOpen(o => !o); }}
        className="inline-flex items-center align-middle"
        aria-label={`${info.label} badge`}
        data-testid={`worker-badge-${tier}`}
      >
        <svg width={dim} height={dim} viewBox="0 0 70 100" style={{ display: "block" }}>
          <path d="M 20 68 L 12 100 L 35 88 L 58 100 L 50 68" fill={info.fill} stroke={info.stroke} strokeWidth="1.5" />
          <circle cx="35" cy="35" r="34" fill={info.fill} stroke={info.stroke} strokeWidth="2.5" />
          <text x="35" y="43" textAnchor="middle" fontSize="26" fontWeight="600" fill={info.text}>
            {info.label[0]}
          </text>
        </svg>
      </button>
      {open && (
        <div
          className="absolute z-20 top-full mt-1 left-0 w-56 p-3 rounded-xl text-xs leading-relaxed shadow-lg bg-popover text-popover-foreground border border-border"
        >
          <p className="font-medium mb-1" style={{ color: info.text }}>{info.label} tier</p>
          <p className="text-muted-foreground">{PERKS[tier]}</p>
        </div>
      )}
    </div>
  );
}